<div class="shop-mobile">
  <div class="shop-mobile-header">
    <button class="arrow-prev color-black btn-icon" aria-label="prev" tabindex="0" (click)="onClickArrowPrev()">
      <sd-icon class="icon-size-s icon-size-md-m" [type]="iconTypes.ARROW_PREV"></sd-icon>
    </button>

    <sd-city-select class="align-items-center"></sd-city-select>
  </div>

  @if (!shops.length) {
    <sd-no-shops></sd-no-shops>
  } @else {
    <div class="shop-mobile-shops-map">
      <sd-shop-map
        class="shop-mobile-shops-map-instance"
        [shops]="shops"
        [showBalloon]="false"
        [mapInstance]="mapInstance"
        (created)="onMapCreated($event)"
        (placemarkClick)="onPlacemarkClick($event)"
        [placemarksProps]="getPlacemarksProps"
      ></sd-shop-map>
    </div>
  }
</div>
